import React from 'react';

const TermsOfUse: React.FC = () => (
  <div className="font-sans antialiased text-gray-800 bg-gradient-to-br from-gray-100 to-gray-300 min-h-screen">
    {/* Header */}
    <div className="py-12 bg-gradient-to-br from-gray-100 to-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Conditions d'utilisation</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">Dernière mise à jour : 19 septembre 2025</p>
        </div>
      </div>
    </div>

    {/* Content */}
    <div className="prose max-w-4xl mx-auto">
      <h2 className="text-2xl font-semibold mt-8 mb-2">1. Acceptation des conditions</h2>
      <p>En installant, accédant ou utilisant l’extension PanierClair (« Extension »), vous acceptez d’être lié par ces Conditions d’Utilisation. Si vous n’acceptez pas ces conditions, veuillez ne pas utiliser l’Extension.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">2. Description du service</h2>
      <p>PanierClair est une extension gratuite et open-source qui affiche des informations supplémentaires sur les produits alimentaires directement sur les pages web, en utilisant la base OpenFoodFacts.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">3. Licence Open Source</h2>
      <p>Le code source de PanierClair est disponible sur <a href="https://github.com/4ntoninFille/PanierClair" target="_blank" rel="noopener noreferrer">GitHub</a> sous licence Apache 2.0.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">4. Utilisation autorisée</h2>
      <p>Vous pouvez utiliser PanierClair à des fins personnelles et non commerciales. Vous acceptez de :</p>
      <ul>
        <li>Respecter les lois et réglementations applicables</li>
        <li>Ne pas tenter de rétroconcevoir, décompiler ou désassembler l’Extension (sauf autorisation par la licence open-source)</li>
        <li>Ne pas utiliser l’Extension à des fins illégales ou interdites</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">5. Activités interdites</h2>
      <ul>
        <li>Utiliser l’Extension pour enfreindre des lois ou réglementations</li>
        <li>Tenter d’interférer avec ou perturber le fonctionnement de l’Extension</li>
        <li>Utiliser l’Extension de manière à endommager, désactiver ou altérer un site web ou service</li>
        <li>Retirer ou modifier tout avis de droit d’auteur, marque ou autre mention propriétaire</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">6. Exclusion de garanties</h2>
      <p>PanierClair est fourni « EN L’ÉTAT » et « SELON DISPONIBILITÉ » sans aucune garantie, expresse ou implicite, notamment :</p>
      <ul>
        <li>L’exactitude ou l’exhaustivité des informations produits affichées</li>
        <li>Le fonctionnement ininterrompu ou sans erreur</li>
        <li>La compatibilité avec tous les sites ou navigateurs</li>
        <li>L’absence de virus ou autres composants nuisibles</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">7. Limitation de responsabilité</h2>
      <p>Dans la limite maximale permise par la loi, les développeurs de PanierClair ne sauraient être tenus responsables de tout dommage indirect, accessoire, spécial, consécutif ou punitif, y compris la perte de profits, de données ou d’utilisation, résultant de l’utilisation de l’Extension.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">8. Mises à jour et modifications</h2>
      <p>Nous nous réservons le droit de modifier, mettre à jour ou interrompre l’Extension à tout moment sans préavis. L’utilisation continue de l’Extension après modification vaut acceptation des nouvelles conditions.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">9. Permissions du navigateur</h2>
      <p>L’Extension peut demander certaines permissions pour fonctionner correctement, telles que :</p>
      <ul>
        <li>Accès au contenu des sites pour identifier les produits</li>
        <li>Permission de modifier l’affichage des pages web</li>
      </ul>
      <p>Ces permissions sont utilisées uniquement pour le fonctionnement de l’Extension et non pour la collecte de données.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">10. Résiliation</h2>
      <p>Vous pouvez cesser d’utiliser l’Extension à tout moment en la désinstallant. Ces conditions restent en vigueur jusqu’à leur résiliation par l’une ou l’autre des parties.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">11. Sites web tiers</h2>
      <p>L’Extension fonctionne sur des sites tiers mais n’approuve ni ne contrôle leur contenu, politiques ou pratiques. Votre utilisation de ces sites est soumise à leurs propres conditions et politiques.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">12. Droit applicable</h2>
      <p>Ces conditions sont régies par les lois françaises, sans égard aux principes de conflit de lois.</p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">13. Contact</h2>
      <p>Pour toute question concernant ces conditions ou l’Extension :</p>
      <ul>
        <li>Email : <a href="mailto:contact@panierclair.fr" className="text-green-600 hover:underline">contact@panierclair.fr</a></li>
        <li>GitHub Issues : <a href="http://github.com/4ntoninFille/PanierClair/issues" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:underline">github.com/4ntoninFille/PanierClair/issues</a></li>
      </ul>

      <hr />
      <p className="font-bold mt-8">En utilisant PanierClair, vous reconnaissez avoir lu, compris et accepté ces Conditions d’Utilisation.</p>
    </div>
    <div className="h-12" />
  </div>
);

export default TermsOfUse;
